import { useEffect, useState } from "react";
import { navLinks } from "../../../mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("ranking");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const ids = navLinks.map((n) => n.id).concat("top");
      let current = "ranking";
      for (const id of ids) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 140) current = id;
      }
      setActive(current === "top" ? "ranking" : current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 items-center justify-between px-4 md:px-6">
        {/* Logo */}
        <a href="#top" className="flex items-center gap-2 cursor-pointer whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-display text-xl text-white">
            9
          </span>
          <span className={`font-serif text-xl font-bold ${solid ? "text-foreground-950" : "text-background-50"}`}>
            看料
          </span>
          <span
            className={`ml-1 hidden sm:inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-medium ${
              solid ? "bg-accent-100 text-accent-800" : "bg-white/15 text-background-50"
            }`}
          >
            <i className="ri-flashlight-fill w-3 h-3 flex items-center justify-center"></i>热瓜追踪
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium transition-colors cursor-pointer ${
                active === n.id
                  ? "bg-primary-500 text-white"
                  : solid
                    ? "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                    : "text-background-100 hover:bg-white/10 hover:text-white"
              }`}
            >
              <i className={`${n.icon} w-4 h-4 flex items-center justify-center`}></i>
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#contact"
            className="hidden sm:inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-send-plane-fill w-4 h-4 flex items-center justify-center"></i>
            投稿线索
          </a>
          <button
            aria-label="打开导航"
            onClick={() => setOpen((v) => !v)}
            className={`md:hidden flex h-10 w-10 items-center justify-center rounded-full border cursor-pointer transition-colors ${
              solid ? "border-background-300 text-foreground-900" : "border-white/30 text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line w-5 h-5 flex items-center justify-center" : "ri-menu-line w-5 h-5 flex items-center justify-center"}></i>
          </button>
        </div>
      </div>

      {/* Mobile panel */}
      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <div className="flex flex-col gap-1">
            {navLinks.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                onClick={() => setOpen(false)}
                className={`flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium cursor-pointer ${
                  active === n.id ? "bg-primary-50 text-primary-700" : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                <i className={`${n.icon} w-4 h-4 flex items-center justify-center`}></i>
                {n.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-white cursor-pointer"
            >
              <i className="ri-send-plane-fill w-4 h-4 flex items-center justify-center"></i>
              投稿线索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}